'use client'

import dynamic from 'next/dynamic'

import { RouteLogicProvider } from '@/features/v2/shared/Header/navbars/navbarPrivate/components/RouteLogicProvider'
import { NavbarEffects } from '@/features/v2/shared/Header/navbars/navbarPrivate/hooks/NavbarEffects'
import { userUIStore } from '@/stores/userUIStore'

const BonusSteps = dynamic(
  () => {
    return import('@/features/Bonus/BonusSteps')
  },
  {
    ssr: false,
    loading: () => {
      return null
    },
  },
)

const DepositModal = dynamic(
  () => {
    return import('@/components/modals/DepositModal')
  },
  {
    ssr: false,
    loading: () => {
      return null
    },
  },
)

export function SessionOverlays() {
  const { isDepositModalOpen, toggleDepositModal } = userUIStore()

  return (
    <>
      <NavbarEffects />
      <RouteLogicProvider>
        {(showBonusOnRoute: boolean) => {
          return (
            <>
              {isDepositModalOpen && (
                <DepositModal
                  isDepositSheetOpen={isDepositModalOpen}
                  setIsDepositSheetOpen={toggleDepositModal}
                />
              )}
              {showBonusOnRoute && <BonusSteps />}
            </>
          )
        }}
      </RouteLogicProvider>
    </>
  )
}
